export class PaginatedData<T> {
  public collectionSize = 0;
  public pageSize = 10;
  public page = 1;
  public collection: Array<T> = [];
  public itemsPerPage: number[] = [10, 20, 50, 100];
}
